import React from 'react';

export const EnvVarsFeaturesContext = React.createContext({
  features: {},
  envVars: {},
});
